module.exports = __webpack_public_path__ + "img/42_24.7494752c.png";